import { computed, watch } from 'vue'
import { createPlpFilterKey } from '../../utils/appliedFilters'
import { useRoute } from '#app/composables/router'

const FILTER_REFRESH_DELAY_MS = 100

export default function usePlpQueryRefresh(refreshProducts: () => unknown) {
  const route = useRoute()
  const filterKey = computed(() => createPlpFilterKey(route.query))

  watch(
    [
      () => route.path,
      () => route.query.sort,
      () => route.query.page,
      filterKey,
    ],
    (
      [path, sort, page],
      [previousPath, previousSort, previousPage],
      onCleanup,
    ) => {
      if (path !== previousPath) {
        return
      }

      if (sort !== previousSort || page !== previousPage) {
        refreshProducts()
        return
      }

      const timeout = setTimeout(refreshProducts, FILTER_REFRESH_DELAY_MS)
      onCleanup(() => clearTimeout(timeout))
    },
  )
}
